module.exports = __webpack_public_path__ + "img/img_industries6.9083242e.jpg";